import { Action, combineReducers } from 'redux';

import { ContentExplorerState, ContentState, SelectionState } from '../../state/ContentExplorerState';
import { contentCountsReducer } from './ContentCountsReducer';
import { contentExplorerToolbarReducer } from './ContentExplorerToolbarReducer';
import { contentFetchBusyReducer } from './ContentFetchBusyReducer';
import { contentMoreItemsForTokenRequestReducer } from './ContentMoreItemsForTokenRequestReducer';
import { contentNextPageTokenReducer } from './ContentNextPageTokenReducer';
import { contentReducer } from './ContentReducer';
import { contentTotalCountReducer } from './ContentTotalCountReducer';
import { contentTypeFilterValuesReducer } from './ContentTypeReducer';
import { mixedContentFilterReducer } from './MixedContentFilterReducer';
import { selectedItemsReducer } from './SelectedItemsReducer';
import { selectionBusyReducer } from './SelectionBusyReducer';
import { showWorkbooksAsViewsReducer } from './ShowWorkbooksAsViewsReducer';

export const contentExplorerReducer: (
  previousState: ContentExplorerState,
  action: Action
) => ContentExplorerState = combineReducers<ContentExplorerState>(
  {
    content: combineReducers<ContentState>({
      contentItems: contentReducer,
      isBusy: contentFetchBusyReducer,
      contentNextPageToken: contentNextPageTokenReducer,
      totalCount: contentTotalCountReducer,
      moreItemsForTokenRequest: contentMoreItemsForTokenRequestReducer
    }),
    contentCounts: contentCountsReducer,
    contentTypeFilterValues: contentTypeFilterValuesReducer,
    mixedContentFilterClauses: mixedContentFilterReducer,
    selection: combineReducers<SelectionState>({
      selectedItems: selectedItemsReducer,
      isBusy: selectionBusyReducer
    }),
    showWorkbooksAsViews: showWorkbooksAsViewsReducer,
    toolbar: contentExplorerToolbarReducer,
  }
);
